import { useConstants } from "~/utils/constants";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const constants: any = useConstants();

  return {
    provide: {
      getFooter: async function() {
        const { data } = await useFetch(config.public.apiBaseUrl + constants.routes.api.global.footer.get);
        return data.value;
      },
      getNavigation: async function() {
        const { data } = await useFetch(config.public.apiBaseUrl + constants.routes.api.global.navigation.get);
        return data.value;
      },
      getGlobal: async function() {
        const { data } = await useFetch(config.public.apiBaseUrl + constants.routes.api.global.global.get);
        return data.value;
      }
    },
  };
});
